module.exports = __webpack_public_path__ + "img/youtube-logo.5ac3ff99.png";